export const DotsHorizontalIcon: React.FC<React.SVGProps<SVGSVGElement>> = (
  props,
) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="100%"
      viewBox="0 0 16 16"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <path d="M7.99984 8.66668C8.36803 8.66668 8.6665 8.3682 8.6665 8.00001C8.6665 7.63182 8.36803 7.33334 7.99984 7.33334C7.63165 7.33334 7.33317 7.63182 7.33317 8.00001C7.33317 8.3682 7.63165 8.66668 7.99984 8.66668Z" />
      <path d="M12.6665 8.66668C13.0347 8.66668 13.3332 8.3682 13.3332 8.00001C13.3332 7.63182 13.0347 7.33334 12.6665 7.33334C12.2983 7.33334 11.9998 7.63182 11.9998 8.00001C11.9998 8.3682 12.2983 8.66668 12.6665 8.66668Z" />
      <path d="M3.33317 8.66668C3.70136 8.66668 3.99984 8.3682 3.99984 8.00001C3.99984 7.63182 3.70136 7.33334 3.33317 7.33334C2.96498 7.33334 2.6665 7.63182 2.6665 8.00001C2.6665 8.3682 2.96498 8.66668 3.33317 8.66668Z" />
    </svg>
  );
};
